export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5409.f840e55e.jpg";